module.exports = __webpack_public_path__ + "assets/icons/pan_tool-24px-99c5.svg";